import { settingsModel } from '../../models/service/settings.model';
import { getLastVisitDate as settingsGetLastVisitDate } from '../../device/settings.storage';

export const getCurrentDate = state => {
    const settings = state.settings[settingsModel.MODEL_NAME];
    const defaultDate = settingsGetLastVisitDate(settings.settings);
    return defaultDate;
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/service/settings.selectors.js